:host {
  height: auto;
  position: relative;
}

.wrapper {
  width: 100%;
  height: 100%;
  padding-top: calc(var(--spacer) * 2);
  padding-bottom: calc(var(--spacer) * 7);
  display: block;

  .form-wrapper {
    display: flex;

    #service-targets-drop-down {
      .dropdown.borderless .dropdown-field {
        border: 1px;
      }
    }

    #targets-tree-wrapper {
      width: 350px;

      #targets-tree {
        overflow: scroll;
        max-height: 300px;
      }
    }

    .selected-targets-wrapper {
      margin-left: 50px;
      display: flex;
      align-items: stretch;
      flex-wrap: wrap;
      column-gap: calc(var(--spacer) * 6);
      width: 350px;

      #selected-targets-title {
        text-transform: uppercase;
        box-sizing: border-box;
        font-family: 'Montserrat SemiBold', 'Montserrat', sans-serif;
        font-weight: 600;
        color: var(--chart-300-icon-buttons);
        text-align: left;
        line-height: 14px;
        padding: 8px 2px 8px 2px;
        border-bottom: 1px solid var(--chart-101-pressed-dividers);
      }

      #group-search {
        width: 540px;
      }
    }
  }

  .loading-container {
    display: none;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    gz-progress-spinner {
      display: flex;
      justify-content: center;
    }
  }

  &.is-loading {
    .form-wrapper {
      display: none;
    }

    .loading-container {
      display: flex;
    }
  }

  #no-targets-selected-error {
    margin-left: -8px;

    &::part(container) {
      width: 870px;
      height: 48px;
      box-sizing: border-box;
      margin-top: 32px;
      text-align: left;
      line-height: 18px;
      margin-bottom: -2px;
    }
  }
}
